import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import { servingTempsTerms } from 'src/util/constants'
import classNames from 'classnames'
import { parseEnumLabel } from 'src/util/helpers'

const ServingTemperature: React.FC = () => {
    const { productData } = useBrewDetailStore()

    const anyServingTemp = productData?.servingTemperature || productData?.style?.servingTemperature
    const servingTemp = anyServingTemp
        ? `${parseEnumLabel(anyServingTemp)} - ${servingTempsTerms[anyServingTemp]}`
        : '--'
    const textClasses = classNames('text-dark ', anyServingTemp && 'font-bold text-lg')

    return (
        servingTemp && (
            <div className='sm:col-span-1 flex flex-col col-span-2 gap-2'>
                <div className='flex items-center gap-1'>
                    <span className='text-base font-bold text-gray-300'>Serving Temperature</span>
                </div>
                <span className={textClasses}>{servingTemp}</span>
            </div>
        )
    )
}

export default ServingTemperature
